import React from "react";
import { ClassificationDetailsTable } from "../classification-details-table/ClassificationDetailsTable";
import { ProductComponent } from "../../graphql/graphql";
import type { TableRef } from "../base-table";

export const ClassificationDetailsModalContent = ({
  tableRef,
  components,
}: {
  tableRef: React.Ref<TableRef>;
  components: ProductComponent[];
}) => (
  <div>
    <ClassificationDetailsTable
      tableRef={tableRef}
      data={components || []}
    />
  </div>
);